import { ReactComponent as AddCorrectionIcon } from './icons/addCorrection.svg';
import { ReactComponent as AttachmentAddIcon } from './icons/attachment-add.svg';
import { ReactComponent as BankAccountsIcon } from './icons/bank-accounts-icon.svg';
import { ReactComponent as DangerIcon } from './icons/danger.svg';
import { ReactComponent as EditIcon } from './icons/edit.svg';
import { ReactComponent as EmailEditIcon } from './icons/email-edit.svg';
import { ReactComponent as EmailSendIcon } from './icons/email-send.svg';
import { ReactComponent as LoadingIcon } from './icons/loading.svg';
import { ReactComponent as LogoutIcon } from './icons/logout.svg';
import { ReactComponent as MarkNotPaidIcon } from './icons/markNotPaid.svg';
import { ReactComponent as NotPaidIcon } from './icons/notpaid.svg';
import { ReactComponent as OverdueIcon } from './icons/overdue.svg';
import { ReactComponent as PaidIcon } from './icons/paid.svg';
import { ReactComponent as PdfIcon } from './icons/pdf.svg';
import { ReactComponent as PreviewIcon } from './icons/preview.svg';
import { ReactComponent as ReinvoiceIcon } from './icons/reinvoice.svg';
import { ReactComponent as RemoveIcon } from './icons/remove.svg';
import { ReactComponent as QueryStatsIcon } from './icons/query-stats.svg';
import loginImage from './images/login.png';
import logoDarkImage from './images/logo_dark.png';
import logoLightImage from './images/logo_light.png';
import logoLightMiniImage from './images/logo_light_mini.png';

export default {
  AddCorrectionIcon,
  AttachmentAddIcon,
  BankAccountsIcon,
  DangerIcon,
  EditIcon,
  EmailEditIcon,
  EmailSendIcon,
  LoadingIcon,
  LogoutIcon,
  MarkNotPaidIcon,
  NotPaidIcon,
  OverdueIcon,
  PaidIcon,
  PdfIcon,
  PreviewIcon,
  ReinvoiceIcon,
  RemoveIcon,
  QueryStatsIcon,
  loginImage,
  logoDarkImage,
  logoLightImage,
  logoLightMiniImage,
};
